import { render, staticRenderFns } from "./area_choise.vue?vue&type=template&id=51628fe4&"
import script from "./area_choise.vue?vue&type=script&lang=js&"
export * from "./area_choise.vue?vue&type=script&lang=js&"
import style0 from "./area_choise.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports